export default __webpack_public_path__ + "static/media/media.c98b9197.jpeg";